import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { InlineEditModule } from '../../global/inline-edit/inline-edit.module';
import { DetailsComponent } from './details.component';
import {MatIconModule} from '@angular/material/icon';

@NgModule({
  declarations: [DetailsComponent],
  imports: [
    CommonModule,
    InlineEditModule,
    ReactiveFormsModule,
    TranslateModule,
    MatTooltipModule,
    MatIconModule,
  ],
  exports: [DetailsComponent],
})
export class DetailsModule {}
